<!--  -->
<template>
<div class='sceneiframe'>
    <i-aside @changeposition="changeposition"></i-aside>
    <iframe :src="`./SuperTwoJiaoYuLu/index.html?m=${link}`" ></iframe>
     <div class="position-layout">
       <ul class="list" v-show="listshow">
        <li v-for="item in list" :key="item.id" @click="switchScene(item)">{{item.position}}</li>
        </ul>
            <div class="position" @click="showList()">
                <i class="icon"></i>当前位置：{{position}} <i class="arrow"></i>
            </div>
   </div>
</div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import aside from '../layout/aside.vue'
export default {
inject: ['reload'],
//import引入的组件需要注入到对象中才能使用
components: {
    'i-aside':aside
},
data() {
//这里存放数据
return {    
    id:'',
    link:'794',
    show:false,
    listshow:false,
    list:[{
        position:'焦裕禄烈士墓',
        id:'792'
    },
        {
        position:'焦桐',
        id:'793'
    },{
        position:'焦裕禄事迹展',
        id:'794'
    }],
    position:"焦裕禄事迹展"
};
},
//监听属性 类似于data概念
computed: {},
//监控data中的数据变化
watch: {},
//方法集合
methods: {
     changeposition() {
        this.show = ! this.show;
    },
    showList() {
        this.listshow = ! this.listshow;
    },
    switchScene(item) {
        this.position = item.position ;
        this.listshow = false;
        this.link = item.id;
        
    },
    getScene() {
        this.scenes.forEach( item=> {
            if(item.id == this.$route.query.id) {
                this.link = item.link
            }
        })
    },
    classifyId() {
        let topic= [7,8,9];
        let life = [6,10];
        console.log(this.id);
        console.log(topic)
        console.log(topic.indexOf(parseInt(this.id)))
        if(life.indexOf(parseInt(this.id)) > -1) {
            { this.life.state = true;}
        }else if(topic.indexOf(parseInt(this.id)) > -1) {
            this.topic.state = true;
        }
        console.log(this.life)
        console.log(this.topic)
    },
    enterScene(id,link) {
        this.$router.push({name:'Scene',query:{id:id},params:{link:link}});
        this.reload();
    },
    expandList(e) {
        if(e=='life') {
            if(!this.life.on) {
                this.life.on = true;
            }else {
                this.life.on = false;
            }
        }else if(e=='topic') {
            if(!this.topic.on) {
                this.topic.on = true;
            }else {
                this.topic.on = false;
            }
        }
    }
},
//生命周期 - 创建完成（可以访问当前this实例）
created() {
   
},
//生命周期 - 挂载完成（可以访问DOM元素）
mounted() {

},
beforeCreate() {}, //生命周期 - 创建之前
beforeMount() {}, //生命周期 - 挂载之前
beforeUpdate() {}, //生命周期 - 更新之前
updated() {}, //生命周期 - 更新之后
beforeDestroy() {}, //生命周期 - 销毁之前
destroyed() {}, //生命周期 - 销毁完成
activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
    .sceneiframe {
        width:100%;
        height:100%;
        iframe {
            width:100%;
            height:100%;
        }
        .list {
        position:absolute;
        right:2vw;
        height:8.4vw;
        bottom:calc(2.8vw + 20px);
        background:rgba(0,0,0,0.3);
        padding:0 2vw;
        border-radius:1vw;
        li {
            line-height:2.8vw;
            height:2.8vw;
            color:#e6e5e5;
            cursor:pointer;
            &:hover {
                color:#a51f24;
            }
        }
    }
    .position {
        position:absolute;
        right:4vw;
        bottom:10px;
        background:rgba(0,0,0,0.3);
        height:2.8vw;
        line-height:2.8vw;
        border-radius:2vw;
        color:#e6e5e5;
        padding:0 2vw;
        font-size:1.3vw;
        padding-left:4vw;
        padding-right:4vw;
        cursor:pointer;
        .icon {
            display:inline-block;
            width:2.34vw;
            height:3.64vw;
            background:url(../../assets/img/position_icon.png) center/100% no-repeat;
            position:absolute;
            bottom:0.2vw;
            left:1vw;
        }
        .arrow {
            position:absolute;
            top:0.2vw;
            right:1.5vw;
            &:after {
                content:'';
                display:inline-block;
                width:0px;
                height:0px;
                border-top: 8px solid #e6e5e5;
                border-right:6px solid transparent;
                border-bottom:4px solid transparent;
                border-left:6px solid transparent;
            }
        }
    }
    }
    @media screen and (max-width:600px){
        .sceneiframe .list {
            right:10px;
            height:84px;
            bottom:40px;
        }
        .sceneiframe .list li {
            line-height:28px;
            height:28px;
            font-size:12px;
        }
        .sceneiframe .position {
            position: absolute;
            right: 70px;
            bottom: 10px;
            background: rgba(0, 0, 0, 0.3);
            height: 30px;
            line-height: 30px;
            border-radius: 10px;
            color: #e6e5e5;
            padding: 0 2vw;
            font-size: 12px;
            padding-left: 30px;
            padding-right: 30px;
            cursor: pointer;
        }
        .sceneiframe .position .icon {
            display: inline-block;
            width: 18px;
            height:30px;            
            position: absolute;
            bottom: 5px;
            left: 1vw;
                
        }
        .sceneiframe .position .arrow {
            top:3px;
        }
    }
</style>